import React from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/01.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/authSlice";
import { RootState, AppDispatch } from "../store/store";
import SearchBar from "./SearchBar";
import SortSelector from "./SortSelector";
import ThemeSwitch from "./ThemeSwitch";
import { useTheme } from "../contexts/ThemeContext";
import { motion } from "framer-motion";
import { resetFavAnimation } from "../store/wordSlice";

const Header = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);
  const { isDarkMode } = useTheme();
  const isFavAnimating = useSelector(
    (state: RootState) => state.words.isFavAnimating
  );

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const handleFavClick = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/favorites");
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{ backgroundColor: isDarkMode ? "#333" : "#ffffff" }}
    >
      <Toolbar>
        {/* Логотип и кнопка "Home" */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="logo"
              style={{
                height: "30px",
                marginBottom: "7px",
                filter: isDarkMode ? "brightness(0) invert(1)" : "none",
                cursor: "pointer",
              }}
            />
          </Link>
          <Button
            color="inherit"
            sx={{ textTransform: "none", marginLeft: 2, color: "#aaaaaa" }}
          >
            <Link
              to="/"
              style={{
                textDecoration: "none",
              }}
            >
              home
            </Link>
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <SortSelector isDarkMode={isDarkMode} />

        <SearchBar isDarkMode={isDarkMode} />

        {/* Анимация кнопки Fav */}
        <motion.div
          initial={{ scale: 1 }}
          animate={{ scale: isFavAnimating ? [1, 1.4, 1] : 1 }}
          transition={{ duration: 0.8, repeat: isFavAnimating ? 3 : 0 }}
          onAnimationComplete={() => {
            if (isFavAnimating) {
              dispatch(resetFavAnimation());
            }
          }}
        >
          <Button
            color="inherit"
            sx={{
              textTransform: "none",
              color: isFavAnimating ? "#ff6ebd" : "#aaaaaa",
            }}
            onClick={handleFavClick}
          >
            <Link
              to="/favorites"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              fav
            </Link>
          </Button>
        </motion.div>

        {/* Кнопка логина */}
        {isLoggedIn ? (
          <Button
            color="inherit"
            sx={{
              fontFamily: "Ubuntu",
              textTransform: "none",
              color: "#aaaaaa",
            }}
            onClick={handleLogout}
          >
            log out
          </Button>
        ) : (
          <Button
            color="inherit"
            sx={{ minWidth: "66px", textTransform: "none", color: "#aaaaaa" }}
          >
            <Link
              to="/login"
              style={{ textDecoration: "none", color: "#aaaaaa" }}
            >
              log in
            </Link>
          </Button>
        )}
        <ThemeSwitch />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
